import { SellingPartyDto } from 'services/APIs/InternalAPI/internal-api.contracts'

export interface IPartyRelationsAPI {
  GetSellers: (organizationId: string) => Promise<SellingPartyDto[]>
}

export enum PartyRelationsOperations {
  'GetSellers' = 'GetSellers',
}
